"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateImageDimensions = calculateImageDimensions;
exports.createStandardSrcSet = createStandardSrcSet;
exports.getResizeOptions = getResizeOptions;
exports.stringifyResizerParams = stringifyResizerParams;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _queryString = _interopRequireDefault(require("query-string"));
/**
 * This file contains all of the resources that we need for
 * dealing with images that are being loaded from our image
 * resizing service.
 *
 * SEE: https://imageresizing.net/
 */

// Formats that can be returned.
var FORMATS = ['jpg', 'png', 'gif'];

// Scale options.
var RESIZER_SCALES = ['down', 'both', 'canvas'];

// Resize mode options.
var RESIZER_MODES = ['pad', 'max', 'crop', 'stretch'];

// Resize anchor point options.
var RESIZER_ANCHOR_POINTS = ['topleft', 'topcenter', 'topright', 'middleleft', 'middlecenter', 'middleright', 'bottomleft', 'bottomcenter', 'bottomright'];

// React's Proptypes can be used for validation of options.
var RESIZE_OPTIONS = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  maxwidth: _propTypes.default.number,
  maxheight: _propTypes.default.number,
  mode: _propTypes.default.oneOf(RESIZER_MODES),
  quality: _propTypes.default.number,
  // default 90
  colors: _propTypes.default.number,
  // 2..256, gifs only
  anchor: _propTypes.default.oneOf(RESIZER_ANCHOR_POINTS),
  scale: _propTypes.default.oneOf(RESIZER_SCALES),
  format: _propTypes.default.oneOf(FORMATS),
  bgcolor: _propTypes.default.string,
  // colour name or hex, e.g. black, 33ddff
  cropxunits: _propTypes.default.number,
  cropyunits: _propTypes.default.number,
  crop(props, propName, componentName) {
    var _context;
    var value = props[propName];
    if (!value || /^(\d+,){3}\d+$/.test(value)) {
      return undefined;
    }
    return new Error((0, _concat.default)(_context = "Invalid prop \"".concat(propName, "\" supplied to \"")).call(_context, componentName, "\"."));
  }
};
var RESIZE_OPTIONS_KEYS = (0, _keys.default)(RESIZE_OPTIONS);
var STANDARD_WIDTHS = [320, 375, 384, 414, 460, 552, 662, 794, 952, 1142, 1370];

/**
 * Extract resize options from the given set.
 *
 * @param {Object} All options.
 *
 * @return {Object} All options that apply to the image resizer.
 */
function getResizeOptions(options) {
  if (!options) return {};
  return (0, _reduce.default)(RESIZE_OPTIONS_KEYS).call(RESIZE_OPTIONS_KEYS, (acc, key) => {
    if (options[key]) {
      acc[key] = options[key];
    }
    return acc;
  }, {});
}

/**
 * Stringifies the formatting parameters such that the format is indicated
 * last. This has been required in some cases where code expects an image
 * url to end in an image-ish extension.
 *
 * @param {Object} params The parameters to stringify.
 *
 * @return {String} The stringified parameters.
 */
function stringifyResizerParams(params) {
  var _context2;
  var {
    format,
    ...options
  } = getResizeOptions(params);
  var query = _queryString.default.stringify(options);
  if (!format) return query;
  return (0, _concat.default)(_context2 = "".concat(query, "&")).call(_context2, _queryString.default.stringify({
    format
  }));
}

/**
 * Constructs a srcset attribute a responsive image.
 *
 * @param {Array} widths - a list of widths
 * @param {Object}
 *
 * @return {Array} - the array of sources
 */
var createSrcSet = function (widths) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return (0, _map.default)(widths).call(widths, width => {
    var _params = {
      ...params,
      descriptor: "".concat(width, "w"),
      width
    };

    // If a ratio is given, force the height parameter as well
    if (ratio) {
      _params.height = Math.round(width / ratio);
    }
    return _params;
  });
};

/**
 * Build a standard srcset using commong widths up to a predefined limit.
 *
 * If a maxWidth is provided, then only widths up to that size will be included
 * in the resulting srcmap; this should be set to the maximum width of the real
 * image in order to avoid generating needlessly large scaled up images.
 */
function createStandardSrcSet() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var ratio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var srcSet = (0, _filter.default)(STANDARD_WIDTHS).call(STANDARD_WIDTHS, width => width <= maxWidth && (!ratio || width / ratio <= maxHeight));
  return createSrcSet(srcSet, params, ratio);
}

/**
 * Determines the appropriate parameters for an image to fetch from
 * the resizing service given an image object (which contains at least
 * a url, width and height) and attrs to be used as resizing params.
 *
 * @param {Object} image
 * @param {Object} attrs
 *
 * @returns {Object} contains {maxWidth, maxHeight, ratio}
 */
function calculateImageDimensions(image, attrs) {
  var maxWidth = attrs.width ? attrs.width : image.width;

  // We need the relative maximun height to create our container.
  var maxHeight = attrs.height ? attrs.height : Math.round(image.height / image.width * maxWidth);
  var ratio = maxWidth / maxHeight;

  // Allow up to 2x specified dimensions for "retina" displays.
  maxWidth = Math.min(2 * maxWidth, image.width); // : image.width;
  maxHeight = Math.min(2 * maxHeight, image.height); // : image.height;

  if (maxWidth / maxHeight !== ratio) {
    // If the retina sizing check breaks the ratio, force it back to the ratio
    maxWidth = maxHeight * ratio;
  }

  /**
   * There are some hard limits on the resizer, so we may have to
   * scale down both width and height.
   */
  if (maxHeight > 3200) {
    var reduction = 3200 / maxHeight;
    maxHeight = 3200;
    maxWidth = Math.floor(maxWidth * reduction);
  }
  if (maxWidth > 3200) {
    var _reduction = 3200 / maxWidth;
    maxWidth = 3200;
    maxHeight = Math.floor(maxHeight * _reduction);
  }
  return {
    maxWidth: Math.round(maxWidth),
    maxHeight: Math.round(maxHeight),
    ratio
  };
}